import { useObjectContext } from '@/hooks/useObjectContext';
import {
	Box,
	Button,
	Chip,
	IconButton,
	Menu,
	MenuItem,
	Stack,
	Tooltip,
	Typography,
	useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INK_MUTED, DIALOG_BORDER, STARTER_PROMPTS } from '../common';
import { useAskAIContext } from '@/context/AskAiContext';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';

const PromptMenu = () => {
	const { isBusy, handleSend, session } = useAskAIContext();
	const sessionId = session?.sessionId ?? session?.id ?? null;

	const disabled = !sessionId || isBusy || Boolean(session?.disabledReason);
	const theme = useTheme();

	const [promptMenuAnchor, setPromptMenuAnchor] = useState(null);

	const handlePromptMenuOpen = (event) => setPromptMenuAnchor(event.currentTarget);
	const handlePromptMenuClose = () => setPromptMenuAnchor(null);

	return (
		<>
			<Tooltip title='Prompt menu'>
				<Button
					variant='text'
					color='inherit'
					onClick={handlePromptMenuOpen}
					disabled={disabled}
					startIcon={<QuestionAnswerOutlinedIcon />}
					sx={{
						textTransform: 'none',
						color: theme.palette.text.secondary,
					}}
				>
					Prompts
				</Button>
			</Tooltip>
			<Menu
				anchorEl={promptMenuAnchor}
				open={Boolean(promptMenuAnchor)}
				onClose={handlePromptMenuClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				{STARTER_PROMPTS.map((prompt) => (
					<MenuItem
						key={prompt.label}
						onClick={() => {
							handlePromptMenuClose();
							handleSend(prompt.prompt);
						}}
						disabled={disabled}
					>
						{prompt.label}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default PromptMenu;
